<script>
import CheckboxComponent from '../__components/CheckboxComponent.vue';
import MixinItem from '../__mixins/item';

export default {
  mixins: [MixinItem],
  components: {
    CheckboxComponent,
  },
  props: {
    value: {
      type: Boolean,
    },
  },
  mounted() {
    this.$emit('fixed-label', true);
    this.$emit('show-border', false);
  },
};
</script>
<template>
  <CheckboxComponent
    :value="value"
    :label="placeholder"
    :disabled="disabled"
    @focus="$emit('focus', $event)"
    @blur="$emit('blur', $event)"
    @input="$emit('input', $event)"
    @change="$emit('change', $event)"
    @submit="$emit('submit', $event)"
  />
</template>
